import BikeSharing from "./bikeSharing";
export default BikeSharing
